@for (quadrant of Quadrants; track quadrant) {
    <adapt-quadrant-view [quadrant]="quadrant"
                         [corner]="QuadrantCorners[quadrant]"
                         [hideOuter]="hideOuter"
                         [isEditing]="isEditing"
                         [isSelecting]="isSelecting"
                         (hasBullseyeStatementChange)="onQuadrantBullseyeChanged(quadrant, $event)"
                         [hasBullseyeStatement]="hasBullseyeStatement"
                         (bullseyeStatementChange)="bullseyeStatementChange.emit($event)"
                         [selectedStatements]="selectedStatements"
                         (statementSelect)="statementSelect.emit($event)"
                         (statementDeselect)="statementDeselect.emit($event)"
                         class="quadrant"></adapt-quadrant-view>
}
@if (showZoom) {
    <i class="zoom-button far"
       [ngClass]="{
            'fa-magnifying-glass-minus': hideOuter,
            'fa-magnifying-glass-plus': !hideOuter,
        }"
       adaptTooltip="Zoom in/out of bullseye"
       (click)="toggleZoom()"
       data-tour="bullseye-zoom-button"></i>
}
